import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { SelectedGuia } from "./type";

type Entity = SelectedGuia;
export interface Deps {
    onSeleccionar: (x: Entity, value: boolean) => void;
}

export function columnas(deps: Deps) {
    const ret: kea.Grid2Column<Entity>[] = [
        { title: "", key: "seleccionar", cell: x => ({ data: x.Selected, view: () => <kea.Checkbox value={x.Selected} onChange={sel => deps.onSeleccionar(x, sel)} /> }) },
        ...columnasFijas
    ];

    const rowStyleCol = kea.applyRowStyleToColumns(ret, (item: Entity) =>
        item.Selected ? { background: "#F7F7D4" } : {});
    return rowStyleCol;
}

export const columnasFijas: kea.Grid2Column<Entity>[] = [
    { title: "Folio", cell: x => ({ data: x.Folio }) },
    { title: "Status", cell: x => ({ data: models.StatusGuia[x.Status] }) },
    { title: "Fecha creación", cell: x => ({ data: kea.toDate(x.FechaCreacion) }) },
    { title: "Cliente origen", cell: x => ({ data: x.NombreClienteOrigen }) },
    { title: "Cliente destino", cell: x => ({ data: x.NombreClienteDestino }) },
    { title: "Destino", cell: x => ({ data: x.DireccionDestinoDTO.Descripcion }) }
];


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargasze/edit/multiselector/columns.tsx